import React from 'react';
import { cn } from '../../utils/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, id, resize = 'vertical', ...props }, ref) => {
    const inputId = id || props.name;
    const resizeStyle: React.CSSProperties =
      resize === 'none'
        ? { resize: 'none' }
        : resize === 'horizontal'
          ? { resize: 'horizontal' }
          : resize === 'both'
            ? { resize: 'both' }
            : { resize: 'vertical' };

    return (
      <div className="app-field">
        {label ? (
          <label htmlFor={inputId} className="app-field__label">
            {label}
            {props.required ? <span className="text-red-500 ml-0.5">*</span> : null}
          </label>
        ) : null}
        <textarea
          ref={ref}
          id={inputId}
          style={resizeStyle}
          className={cn('app-textarea', error && 'is-invalid', className)}
          {...props}
        />
        {error ? <p className="app-field__error">{error}</p> : null}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
